// extracted by mini-css-extract-plugin
module.exports = {"container":"SubsidyCardList_container__26xD9","sending":"SubsidyCardList_sending__y0vD_"};